import { useContext } from 'react';
import { type EditorFieldWithoutRelations } from '@/lib/types';
import ModelsContext from '@/pages/EditorPage/ChallengeModelsEditor/ModelsContext';
import FieldContext from '../../FieldContext';
import VisibilityDatesManager, {
  type VisibilityDatesManagerProps,
} from '../../../VisibilityDatesManager';
import SelectedModelIdContext from '../../../../../SelectedModelIdContext';

type FieldVisibilityDatesProps = Omit<
  VisibilityDatesManagerProps<EditorFieldWithoutRelations>,
  'variant' | 'fieldOrSection' | 'updateFieldOrSectionInLocalState'
>;

const FieldVisibilityDates = (props: FieldVisibilityDatesProps) => {
  const [, setModels] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);
  const { field } = useContext(FieldContext);

  return (
    <VisibilityDatesManager
      variant="field"
      fieldOrSection={field!}
      updateFieldOrSectionInLocalState={(
        updatedField: EditorFieldWithoutRelations,
      ): void => {
        setModels(models => {
          models[selectedModelId].fields[field!.id] = {
            ...models[selectedModelId].fields[field!.id],
            ...updatedField,
          };
        });
      }}
      {...props}
    />
  );
};

export default FieldVisibilityDates;
